import { Component, Input, OnInit } from '@angular/core';
import { texts } from './candidate-education.texts';

@Component({
  standalone: false,
  selector: 'app-candidate-education',
  templateUrl: './candidate-education.component.html',
  styleUrls: ['./candidate-education.component.scss']
})
export class CandidateEducationComponent implements OnInit {

  texts = texts;

  @Input()
  candidate : any;
  
  constructor() { }

  ngOnInit() {
  }

}
